import { Auth, Customer } from "@/types/__gql__"
import { useLazyQuery, useQuery, gql } from "@apollo/client"

import { useEffect } from "react"
import { CUSTOMER_FRAGMENT } from "./useCustomer"

export const GET_CUSTOMER = gql`
  query CustomerRes($customerId: String!) {
    customer(customerId: $customerId) {
      ...CustomerFragment
    }
  }
  ${CUSTOMER_FRAGMENT}
`
export const GET_SESSION = gql`
  query AuthRes {
    auth {
      id
      firstname
      lastname
      email
      roles
      customer {
        id
        customerName
      }
    }
  }
`

export const useSwitchCustomer = (customerId?: string) => {
  const [getCustomer, { data, loading, error }] = useLazyQuery<
    { customer: Customer },
    { customerId: string }
  >(GET_CUSTOMER)
  useEffect(() => {
    customerId && getCustomer({ variables: { customerId: customerId } })
  }, [customerId, getCustomer])

  return {
    loading,
    error,
    data: data?.customer,
    getCustomer
  }
}

export const useLoginUser = () => {
  const { loading, data, error } = useQuery<{ auth: Auth }>(GET_SESSION)

  return {
    loading,
    error,
    data: data?.auth
  }
}
